(function ($) {
  let slideBarToggle = null;
  const ANIMATION_DURATION = 400; // doit correspondre à $gen-t en ms

  function toggleDropdown(event, $toggle) {
    event.preventDefault();
    event.stopPropagation();

    const $li = $toggle.closest('.dropdown');
    const $subnav = $li.children('.dropdown__subnav-wrapper');

    if ($li.hasClass('opened')) {
      $li.removeClass('opened');
      $toggle.attr('aria-expanded', 'false');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-open'));
      $subnav.slideUp('fast');
    } else {
      $li.addClass('opened');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
      $subnav.slideDown('fast');
    }
  }

  function prepareDropdownForNav($nav) {
    $nav.find('.active').each(function () {
      const $li = $(this);
      $li.addClass('opened');

      const $toggle = $li.find('> .nav-item__link-wrapper > .dropdown__toggle');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
    });

    $nav
      .find('.dropdown')
      .not('.opened')
      .each(function () {
        $(this).children('.dropdown__subnav-wrapper').slideUp(0);
      });

    $nav.find('.dropdown__toggle').on('click', function (event) {
      toggleDropdown(event, $(this));
    });

    $nav
      .find('.nav-item--heading > .nav-item__link-wrapper > .nav-item__link')
      .on('click', function (event) {
        toggleDropdown(event, $(this).next('.dropdown__toggle'));
      });
  }

  function closeSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open').addClass('mobile-menu-closing');

    setTimeout(() => {
      $('body').removeClass('mobile-menu-closing');
    }, ANIMATION_DURATION);

    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
  }

  function tryClosingSlidebarMenu(event) {
    if (typeof event.keyCode !== 'undefined') {
      if (event.keyCode === 27) {
        $('.vtx-burger-container').focus();
        closeSlidebarMenu();
      }
    } else if (!$(event.target).closest('#mobile-menu-wrapper').length) {
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
  }

  function initMenuMobile() {
    slideBarToggle = $('.vtx-burger-container');
    const $mobileMenu = $('#mobile-menu');

    slideBarToggle.on('click', function (event) {
      event.stopPropagation();
      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });

    prepareDropdownForNav($mobileMenu.find('.nav-mobile'));
  }

  $(document).ready(function () {
    initMenuMobile();
  });
})(jQuery);
